import { Field, FieldProps } from 'formik';
import React from 'react';
import { Button } from '@mss/mss-component-library';

export const SubmitButton = ({
  children,
  theming = 'site',
  ...restProps
}: React.ComponentProps<typeof Button>) => (
  <Field>
    {({ form: { isSubmitting } }: FieldProps) => (
      <Button
        loading={isSubmitting}
        theming={theming}
        variant="primary"
        htmlType="submit"
        type="submit"
        data-ta="submitButton"
        disabled={restProps.disabled || isSubmitting}
        {...restProps}
      >
        {children}
      </Button>
    )}
  </Field>
);

export default SubmitButton;
